import { render, staticRenderFns } from "./PurchaseOrderHeaderForm.vue?vue&type=template&id=8f3c0a34&scoped=true&"
import script from "./PurchaseOrderHeaderForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderHeaderForm.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderHeaderForm.vue?vue&type=style&index=0&id=8f3c0a34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3c0a34",
  null
  
)

export default component.exports